module.exports = __webpack_public_path__ + "static/media/tradehero.808028bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tradehero.png
// module id = 30
// module chunks = 0